import navShop from "@assets/imgs/navs/shop-nav.png";
import navShopActive from "@assets/imgs/navs/shop-nav-active.png";
import navHome from "@assets/imgs/navs/home-nav.png";
import navHomeActive from "@assets/imgs/navs/home-nav-active.png";
import navCodex from "@assets/imgs/navs/codex-nav.png";
import navCodexActive from "@assets/imgs/navs/codex-nav-active.png";
import { AudioManager } from "@/phaser/core/audio/AudioManager";
import { BaseButton } from "@phaser/ui/btns/BaseButton";

export type NavSceneType = "SHOP" | "HOME" | "CODEX";

interface BottomNavBtnOptions {
  targetScene: string;
  isActive?: boolean;
  defaultKey: string;
  activeKey: string;
}

export class BottomNavBtn extends BaseButton {
  private bg: Phaser.GameObjects.Image;
  private isActive: boolean;
  private defaultKey: string;
  private activeKey: string;

  static preload(scene: Phaser.Scene) {
    scene.load.image("nav-shop", navShop);
    scene.load.image("nav-shop-active", navShopActive);

    scene.load.image("nav-home", navHome);
    scene.load.image("nav-home-active", navHomeActive);

    scene.load.image("nav-codex", navCodex);
    scene.load.image("nav-codex-active", navCodexActive);
  }

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    options: BottomNavBtnOptions,
  ) {
    const isActive = options.isActive ?? false;

    super(scene, x, y, {
      onClick: () => {
        if (scene.scene.key !== options.targetScene) {
          scene.scene.start(options.targetScene);
        }
      },
      sfx: () => AudioManager.playSfx("sfx-button"),
      onPress: () => this.setPressedStyle(),
      onRelease: () => this.resetButton(),
    });

    this.isActive = isActive;
    this.defaultKey = options.defaultKey;
    this.activeKey = options.activeKey;

    this.bg = scene.add
      .image(
        0,
        this.isActive ? 60 : 0,
        this.isActive ? this.activeKey : this.defaultKey,
      )
      .setOrigin(0.5);

    this.add(this.bg);

    if (!this.isActive) {
      this.enableButton(this.bg.width, this.bg.height);
    }

    scene.add.existing(this);
  }

  private setPressedStyle() {
    if (this.isActive) return;

    this.bg.setTexture(this.activeKey);
    this.bg.y = 60;
  }

  private resetButton() {
    if (this.isActive) return;

    this.bg.setTexture(this.defaultKey);
    this.bg.y = 0;
  }
}
